<template>
    <div style="position: fixed;right: 1rem;bottom: 2rem; display: flex; flex-direction: column;justify-content: end; align-items: end;z-index: 1000;">
        <div class="btn-group mb-2" v-for="(item, index) in tags" :key="index">
            <button v-if="item.isTag == true" @click="PRINT_TAG(item.id, index)" type="button" class="btn btn-success rounded-pill btn-h w-auto" style="padding-right: 36px;">
                <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="loadings.filter(e => e == index).length == 1">
                    <span class="sr-only">Loading...</span>
                </div>
                <div class="d-flex" v-else>
                    <i class="bi bi-printer mr-2"></i>
                    <small>Imprimir TAG "{{ item.type }}{{ item.id }}"</small>
                </div>
            </button>
            <a v-else :class="typeof item.error == 'boolean' && item.error == true ? 'bg-soft-danger text-danger disabled' : item.class" :href="item.href" target="_blank" class="btn rounded-pill btn-h w-auto"
                style="padding-right: 36px;">
                <v-tooltip bottom class="mx-1">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="nowrap">
                            <div class="d-flex" v-if="typeof item.error == 'boolean' && item.error == true">
                                <i class="mr-2 bi bi-exclamation-circle"></i>
                                {{ item.title }}
                            </div>
                            <div v-else>
                                <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="!item.href || typeof item.href == 'undefined'">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div class="d-flex" v-else>
                                    <i class="mr-2" :class="item.icon"></i>
                                    {{ item.title }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <small>
                        <div>{{ item.title }}</div>
                    </small>
                </v-tooltip>
            </a>
            <button @click="$store.dispatch('REMOVE_TAGS', index)" type="button"
                :class="typeof item.error == 'boolean' && item.error == true ? 'text-danger border-danger' : 'text-success border-success'"
                class="btn btn-light rounded-pill btn-m position-absolute"
                style="right: 0;z-index: 1;">
                <i class="bi bi-x"></i>
            </button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            loadings: [],
        }
    },
    computed: {
        ...mapGetters([
            'tags',
        ])
    },
    methods: {
        PRINT_TAG: function(print, index){
            let vue = this
            if(vue.loadings.filter(e => e == index).length == 0){
                vue.loadings.push(index)
                axios({url: '/print/package/' + print + '/tag', method: 'GET', responseType: 'blob' })
                .then((response) => {
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(response.data)
                    link.target = '_blank'
                    link.rel = "noopener"
                    link.click()
                })
                .finally((resp)=>{
                    vue.loadings.splice(vue.loadings.findIndex(e => e == index), 1)
                    vue.$store.dispatch('REMOVE_TAGS', index)
                })
            }
        }
    }   
}
</script>